export default __webpack_public_path__ + "static/media/extra_out_r9.19842f96.svg";